// MachineUtilizationDashboard/components/RuntimeTargetChart.jsx

import Chart from "react-apexcharts";
import { formatNumber, truncateText } from "../utils/machineDashboardUtils";

function RuntimeTargetChart({ data = [] }) {
  const machines = Array.isArray(data)
    ? [...data]
        .sort((a, b) => {
          const deptCompare = String(a?.deptCode || "").localeCompare(
            String(b?.deptCode || ""),
          );

          if (deptCompare !== 0) {
            return deptCompare;
          }

          return String(a?.machineCode || "").localeCompare(
            String(b?.machineCode || ""),
          );
        })
        .slice(0, 15)
    : [];

  const chartOptions = {
    chart: {
      type: "bar",
      animations: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
      parentHeightOffset: 0,
    },

    colors: ["#053c83", "#94a3b8"],

    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 5,
        columnWidth: "58%",
      },
    },

    dataLabels: {
      enabled: false,
    },

    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },

    xaxis: {
      categories: machines.map((item) =>
        truncateText(item?.machineCode || "-", 12),
      ),

      labels: {
        rotate: -45,

        style: {
          colors: "#64748b",
          fontSize: "13px",
        },
      },
    },

    yaxis: {
      min: 0,

      title: {
        text: "Hours",
      },

      labels: {
        formatter: (value) => formatNumber(value, 1),
      },
    },

    legend: {
      position: "top",
      horizontalAlign: "right",
      fontSize: "11px",
      markers: {
        width: 8,
        height: 8,
      },
    },

    grid: {
      borderColor: "#edf2f7",
      strokeDashArray: 4,
    },

    tooltip: {
      shared: true,
      intersect: false,

      y: {
        formatter: (value) => `${formatNumber(value, 2)} hours`,
      },
    },
  };

  const series = [
    {
      name: "Actual Runtime",
      data: machines.map((item) => Number(item?.actualHours || 0)),
    },
    {
      name: "Target Duration",
      data: machines.map((item) => Number(item?.targetHours || 0)),
    },
  ];

  if (machines.length === 0) {
    return <div className="mud-empty-state">No runtime data available.</div>;
  }

  return (
    <Chart
      key={`runtime-${machines.map((item) => item.machineCode).join("-")}`}
      options={chartOptions}
      series={series}
      type="bar"
      height={390}
    />
  );
}

export default RuntimeTargetChart;
